/**
 * created by zhouzt on 2020-04-20
 *
 * description: 类目查询接口地址
 *
 */

const config = require('libs/config')

const category = {
	// 根据父 id 获取
	// queryById: config.MS_XY_PATH + '/outline/inquiry/queryCategoryByParentId',
	// 根据名称获取
	// queryByName: config.MS_XY_PATH + '/outline/inquiry/queryCategoryByKeyword',

	// 根据父 id 获取
	queryById: config.MS_XY_PATH + '/outline/inquiry/child/list',
	// 根据名称获取
	queryByName: config.MS_XY_PATH + '/outline/inquiry/queryCategoryByName'

}

export default category



// WEBPACK FOOTER //
// ./src/api/category/index.js